module.exports = __webpack_public_path__ + "static/media/siter.and.brother.kids.980eda9b.png";